import { format, addMinutes } from "date-fns";
import { ms } from "date-fns/locale";
import { Repeat, Timer } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const SPACINGS = [0, 5, 10, 15, 30, 60];
const REPEATS = [{ v: "none", l: "Sekali" }, { v: "daily", l: "Setiap hari" }, { v: "weekly", l: "Setiap minggu" }];

export default function ScheduleOptions({ start, count, spacing, setSpacing, repeat, setRepeat, until, setUntil }) {
  const last = count > 1 && spacing ? addMinutes(start, spacing * (count - 1)) : null;
  return (
    <div className="mt-5 space-y-5 border-t border-border pt-5">
      <div>
        <p className="mb-2 flex items-center gap-1.5 text-sm font-medium"><Timer className="h-4 w-4 text-primary" /> Jarak antara group</p>
        <Select value={String(spacing)} onValueChange={(v) => setSpacing(Number(v))} disabled={count < 2}>
          <SelectTrigger className="bg-background" data-testid="composer-spacing-select"><SelectValue /></SelectTrigger>
          <SelectContent>
            {SPACINGS.map((m) => <SelectItem key={m} value={String(m)}>{m === 0 ? "Serentak (tiada jarak)" : `${m} minit`}</SelectItem>)}
          </SelectContent>
        </Select>
        <p className="mt-2 text-xs text-muted-foreground" data-testid="composer-spacing-summary">
          {count < 2 ? "Pilih 2 sasaran atau lebih untuk guna jarak." : last ? `Sasaran terakhir pada ${format(last, "h:mm a, d MMM", { locale: ms })}` : "Semua sasaran pada masa yang sama."}
        </p>
      </div>
      <div>
        <p className="mb-2 flex items-center gap-1.5 text-sm font-medium"><Repeat className="h-4 w-4 text-violet-300" /> Ulang post</p>
        <div className="grid grid-cols-3 gap-2">
          {REPEATS.map(({ v, l }) => (
            <button key={v} type="button" onClick={() => setRepeat(v)} className={`rounded-lg border py-2 text-xs transition-colors ${repeat === v ? "border-violet-500/60 bg-violet-500/15 text-white" : "border-border text-muted-foreground hover:text-white"}`} data-testid={`composer-repeat-${v}`}>
              {l}
            </button>
          ))}
        </div>
        {repeat !== "none" && (
          <div className="mt-3 space-y-1.5">
            <p className="text-xs text-muted-foreground">Sehingga (kosongkan untuk berterusan)</p>
            <Input type="date" value={until} onChange={(e) => setUntil(e.target.value)} className="bg-background" data-testid="composer-repeat-until-input" />
          </div>
        )}
      </div>
    </div>
  );
}
